/**
 * The expense route table (design C3 §5.9, §6.6).
 *
 * Exported as `EXPENSE_ROUTES` and mounted by **P9** in
 * `web/src/router/index.ts`.
 *
 * `/expense/claims/:id` is declared **after** the fixed-word routes for the same
 * reason AR and Assets order theirs: the `\d+` constraint already makes `new`
 * unparseable as an id, and the ordering makes that obvious to whoever edits it
 * next.
 */

import type { RouteRecordRaw } from 'vue-router'

import { EXPENSE_PERMISSIONS } from '@/modules/expense/permissions'

export const EXPENSE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/expense/claims',
    name: 'expense-claims',
    component: () => import('@/modules/expense/ClaimsListView.vue'),
    meta: { titleKey: 'expense.routeTitles.claims', permission: EXPENSE_PERMISSIONS.claimRead },
  },
  {
    path: '/expense/approvals',
    name: 'expense-approvals',
    component: () => import('@/modules/expense/ApprovalsView.vue'),
    meta: { titleKey: 'expense.routeTitles.approvals', permission: EXPENSE_PERMISSIONS.claimApprove },
  },
  {
    path: '/expense/travel',
    name: 'expense-travel',
    component: () => import('@/modules/expense/TravelView.vue'),
    meta: { titleKey: 'expense.routeTitles.travel', permission: EXPENSE_PERMISSIONS.travelRead },
  },
  {
    path: '/expense/advances',
    name: 'expense-advances',
    component: () => import('@/modules/expense/AdvancesView.vue'),
    meta: { titleKey: 'expense.routeTitles.advances', permission: EXPENSE_PERMISSIONS.travelRead },
  },
  {
    path: '/expense/payroll-inclusions',
    name: 'expense-payroll-inclusions',
    component: () => import('@/modules/expense/PayrollInclusionsView.vue'),
    meta: {
      titleKey: 'expense.routeTitles.payrollInclusions',
      permission: EXPENSE_PERMISSIONS.claimSettlePayroll,
    },
  },
  {
    path: '/expense/cards',
    name: 'expense-cards',
    component: () => import('@/modules/expense/CardStatementsView.vue'),
    meta: { titleKey: 'expense.routeTitles.cards', permission: EXPENSE_PERMISSIONS.cardRead },
  },
  {
    path: '/expense/policies',
    name: 'expense-policies',
    component: () => import('@/modules/expense/PoliciesView.vue'),
    meta: { titleKey: 'expense.routeTitles.policies', permission: EXPENSE_PERMISSIONS.policyRead },
  },
  {
    path: '/expense/claims/:id(\\d+)',
    name: 'expense-claim',
    component: () => import('@/modules/expense/ClaimView.vue'),
    meta: { titleKey: 'expense.routeTitles.claim', permission: EXPENSE_PERMISSIONS.claimRead },
  },
  {
    path: '/expense/cards/:id(\\d+)',
    name: 'expense-card-statement',
    component: () => import('@/modules/expense/CardMatchView.vue'),
    meta: { titleKey: 'expense.routeTitles.cardStatement', permission: EXPENSE_PERMISSIONS.cardRead },
  },
]
